import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow3",
  "use": "icon-arrow3-usage",
  "viewBox": "0 0 8 4",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 4\" id=\"icon-arrow3\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.646 3.646a.5.5 0 0 0 .708 0L7.146.854A.5.5 0 0 0 6.793 0H1.207a.5.5 0 0 0-.353.854l2.792 2.792Z\" fill=\"#4066D4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol